import { render, staticRenderFns } from "./InboxWindowNew.vue?vue&type=template&id=8fca0dfa"
import script from "./InboxWindowNew.vue?vue&type=script&lang=ts"
export * from "./InboxWindowNew.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fca0dfa')) {
      api.createRecord('8fca0dfa', component.options)
    } else {
      api.reload('8fca0dfa', component.options)
    }
    module.hot.accept("./InboxWindowNew.vue?vue&type=template&id=8fca0dfa", function () {
      api.rerender('8fca0dfa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inbox/InboxWindowNew.vue"
export default component.exports